// NOTE: for internal usage only
export class ChatApi {
  static load(): Promise<any> {
    return import(/* webpackChunkName: "hpe.chat-api.js" */'hpe-chats/hpe-chat-api').then(({HpeChatApi}) => HpeChatApi);
  }
}
